import { CancellationBanner } from 'new-components/OpAppScaffold/components/CancellationBanner';

export const OpAppBanners = () => {
  return (
    <div className="op-app-banners">
      <CancellationBanner />
    </div>
  );
};
